import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Phone, ArrowRight, Package } from "lucide-react";
import { ACCESSORIES, COMPANY } from "@/lib/site-data";

export default function PonyvaKiegeszitok() {
  return (
    <div className="bg-white">
      {/* Hero */}
      <section className="relative pt-28 md:pt-36 pb-16 md:pb-24 overflow-hidden">
        <div className="absolute inset-0 -z-10 bg-gradient-to-b from-[#F8FAFC] to-white" />
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl"
          >
            <span className="eyebrow">Ponyva kiegészítők</span>
            <h1 className="mt-3 font-heading font-extrabold text-[#0B192C] text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
              Minden, ami a ponyva köré tartozik.
            </h1>
            <p className="mt-5 text-gray-600 text-base sm:text-lg leading-relaxed max-w-2xl">
              Hevederek, ringlik, fülek, görgők és további ipari kiegészítők –
              raktárról, vagy egyedi méretben. A ponyva mellé azt is megtaláljuk,
              ami a tartós használathoz kell.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Specs table - rare design element */}
      <section className="pb-16 md:pb-24">
        <div className="max-w-5xl mx-auto px-4 md:px-8">
          <div className="bg-white border border-gray-200 rounded-lg shadow-sm overflow-hidden">
            <div className="bg-[#0B192C] text-white px-6 py-4 grid grid-cols-12 text-xs uppercase tracking-widest font-semibold">
              <div className="col-span-1 hidden md:block">#</div>
              <div className="col-span-7 md:col-span-4">Tartozék</div>
              <div className="col-span-5 md:col-span-4">Leírás</div>
              <div className="col-span-12 md:col-span-3 mt-1 md:mt-0 text-right md:text-left">Specifikáció</div>
            </div>
            {ACCESSORIES.map((a, i) => (
              <motion.div
                key={a.name}
                initial={{ opacity: 0, x: -10 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.35, delay: i * 0.04 }}
                data-testid={`accessory-${i}`}
                className="px-6 py-4 grid grid-cols-12 items-center border-t border-gray-100 hover:bg-[#F8FAFC] transition-colors group"
              >
                <div className="col-span-1 hidden md:block text-xs font-heading font-bold text-[#EA580C]">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="col-span-7 md:col-span-4 flex items-center gap-3">
                  <div className="w-9 h-9 rounded-md bg-[#1E3E62]/5 text-[#1E3E62] flex items-center justify-center group-hover:bg-[#EA580C] group-hover:text-white transition-colors shrink-0">
                    <Package className="w-4 h-4" />
                  </div>
                  <span className="font-heading font-bold text-[#0B192C]">
                    {a.name}
                  </span>
                </div>
                <div className="col-span-5 md:col-span-4 text-sm text-gray-600">
                  {a.desc}
                </div>
                <div className="col-span-12 md:col-span-3 mt-1 md:mt-0 text-right md:text-left">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-[#EA580C]/10 text-[#EA580C] text-xs font-semibold">
                    {a.spec}
                  </span>
                </div>
              </motion.div>
            ))}
          </div>
          <div className="mt-6 text-xs text-gray-500">
            * További kiegészítőkkel és egyedi méretekkel kapcsolatban hívjon vagy küldje el ajánlatkérését.
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#0B192C] text-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <h3 className="font-heading font-bold text-2xl md:text-3xl">
              Pótalkatrészre van szüksége?
            </h3>
            <p className="mt-2 text-gray-300">
              Hívjon és pontosítsuk az igényt – legtöbb tartozék azonnal raktáron.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <Button asChild className="bg-[#EA580C] hover:bg-[#C2410C] h-12 px-6 font-semibold">
              <Link to="/#ajanlat">Ajánlatkérés <ArrowRight className="w-4 h-4" /></Link>
            </Button>
            <a href={`tel:${COMPANY.phoneRaw}`} className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border-2 border-white/30 hover:bg-white hover:text-[#0B192C] font-semibold transition-colors">
              <Phone className="w-4 h-4" />{COMPANY.phone}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
